"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var Editions = _interopRequireWildcard(require("self-service-api/constants/Editions"));

var _ProductOwnershipSelectors = require("pricing-pages-unified-ui/selectors/ProductOwnershipSelectors");

var _ADDON_BRAND_DOMAIN$A;

var includesMarketingPro = function includesMarketingPro(_ref) {
  var marketingPlanSelected = _ref.marketingPlanSelected;
  return marketingPlanSelected === _MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL || marketingPlanSelected === _MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL_MC;
};

var includesMarketingEnt = function includesMarketingEnt(_ref2) {
  var marketingPlanSelected = _ref2.marketingPlanSelected;
  return marketingPlanSelected === _MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE || marketingPlanSelected === _MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE_MC;
};

var includesCmsEnt = function includesCmsEnt(_ref3) {
  var cmsPlanSelected = _ref3.cmsPlanSelected;
  return cmsPlanSelected === _MerchandiseIds.PRODUCT_CMS_ENTERPRISE;
};

var _default = (_ADDON_BRAND_DOMAIN$A = {}, (0, _defineProperty2.default)(_ADDON_BRAND_DOMAIN$A, _MerchandiseIds.ADDON_BRAND_DOMAIN, {
  isRestricted: function isRestricted(selections) {
    return !includesMarketingEnt(selections) && !includesCmsEnt(selections);
  },
  restrictionKey: 'includeMarketingEntOrCmsEnt'
}), (0, _defineProperty2.default)(_ADDON_BRAND_DOMAIN$A, _MerchandiseIds.ADDON_DEDICATED_IP, {
  isRestricted: function isRestricted(selections) {
    return !includesMarketingPro(selections) && !includesMarketingEnt(selections);
  },
  restrictionKey: 'includeMarketingProOrEnt'
}), (0, _defineProperty2.default)(_ADDON_BRAND_DOMAIN$A, _MerchandiseIds.ADDON_TRANSACTIONAL_EMAIL, {
  isRestricted: function isRestricted(selections) {
    return !includesMarketingPro(selections) && !includesMarketingEnt(selections);
  },
  restrictionKey: 'includeMarketingProOrEnt'
}), (0, _defineProperty2.default)(_ADDON_BRAND_DOMAIN$A, _MerchandiseIds.ADDON_CUSTOM_SSL, {
  isRestricted: function isRestricted(_ref4, state) {
    var servicePlanSelected = _ref4.servicePlanSelected,
        marketingPlanSelected = _ref4.marketingPlanSelected,
        cmsPlanSelected = _ref4.cmsPlanSelected;
    var merchandiseMap = (0, _MerchandiseSelectors.merchandiseSelector)(state);
    if (!merchandiseMap) return false;
    var ownsQualifyingProduct = (0, _ProductOwnershipSelectors.ownsProductOrHigherSelector)(state, _MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL) || (0, _ProductOwnershipSelectors.ownsProductOrHigherSelector)(state, _MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL) || (0, _ProductOwnershipSelectors.ownsProductOrHigherSelector)(state, _MerchandiseIds.PRODUCT_CMS_PROFESSIONAL);
    if (ownsQualifyingProduct) return false;
    var allowedEditions = [Editions.PROFESSIONAL, Editions.ENTERPRISE];
    return ![servicePlanSelected, marketingPlanSelected, cmsPlanSelected].some(function (plan) {
      return plan && allowedEditions.includes(merchandiseMap[plan].edition);
    });
  }
}), _ADDON_BRAND_DOMAIN$A);

exports.default = _default;
module.exports = exports.default;